import { vec } from "excalibur";
import GameApp from "../../../index";
import Location from "@/scenes/location";
import { Figure, FigureState } from "@/actors/figure";

export class FurnitureActionsHandler {
  static resetPlayerStateToIdle(scene: any, furniture: any) {
    const player = scene.figureManager.getFigureByPosition({
      x: furniture.instance.x,
      y: furniture.instance.y,
    }) as Figure;

    if (player) {
      player.isSitting = false;
      player.fsm.setState(FigureState.Idle);
    }
  }

  static async handle(data: {
    action: any;
    id: number;
    state: any;
    solidTiles: any[];
    unsolidTiles: any[];
    isNew: any;
    furniture: { id: number; x: any; y: any };
    occupiedPosition: any;
  }) {
    const scene = GameApp.game.currentScene as Location;

    let furniture: any = null;
    switch (data.action) {
      case "set_state":
        furniture = scene.furnitureManager.getById(data.id) as any;
        furniture?.instance.toggleAnimationState(data.state);
        break;

      case "move":

        furniture = scene.furnitureManager.getById(data.id) as any;
        console.log(typeof data.id, data.id, scene.furnitureManager.getById(1))
        furniture?.instance.move(furniture.instance.x, furniture.instance.y);

        FurnitureActionsHandler.resetPlayerStateToIdle(scene, furniture);
        break;

      case "rotate":
        furniture = scene.furnitureManager.getById(data.id) as any;
        furniture?.instance.rotate();

        // // Set solid tiles
        // data.solidTiles.forEach((element) => {
        //   scene.roomTileMap.setSolidTile(vec(element.x, element.y));
        // });

        // // Clear solid tiles
        // data.unsolidTiles.forEach((element) => {
        //   scene.roomTileMap.removeSolidTile(vec(element.x, element.y));
        // });

        break;

      case "pickup":
        furniture = scene.furnitureManager.removeById(data.id);
        if (furniture) scene.remove(furniture.instance);

        FurnitureActionsHandler.resetPlayerStateToIdle(scene, furniture);

        break;

      case "drop":
        if (data.isNew) {
          scene.addFurnituresToRoom([data.furniture]);

          // Set solid tiles
          data.solidTiles.forEach((element) => {
            scene.roomTileMap.setSolidTile(vec(element.x, element.y));
          });

          // Clear solid tiles
          data.unsolidTiles.forEach((element) => {
            scene.roomTileMap.removeSolidTile(vec(element.x, element.y));
          });
        } else {
          furniture = scene.furnitureManager.getById(data.furniture.id) as any;

          // Set solid tiles
          data.solidTiles.forEach((element) => {
            scene.roomTileMap.setSolidTile(vec(element.x, element.y));
          });

          // Clear solid tiles
          data.unsolidTiles.forEach((element) => {
            scene.roomTileMap.removeSolidTile(vec(element.x, element.y));
          });

          // Set new position
          furniture.instance.setPosition(
            scene,
            data.furniture.x,
            data.furniture.y
          );

          scene.furnitureManager.updateOccupiedPosition(
            data.furniture.id,
            data.occupiedPosition
          );

          FurnitureActionsHandler.resetPlayerStateToIdle(scene, furniture);



          // Close furniviewer
          scene.furniViewer?.closeView();
        }
        break;
    }
  }
}
